// @flow
import styled from "styled-components"

export const InventoryWrap = styled.div`
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: inherit;
    flex-wrap: wrap;
    max-width: 96rem;
`



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/InventorySelector/styled.js